import { render, staticRenderFns } from "./popup_services-error.vue?vue&type=template&id=0be81e3b"
import script from "./popup_services-error.vue?vue&type=script&lang=js"
export * from "./popup_services-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports